import { w } from 'windstitch';

export const Wrapper = w.div(
  'w-full xl:w-[1200px] p-4 xl:p-0 my-[36px] lg:my-[128px] flex  flex-col lg:flex-row gap-y-[36px] lg:gap-x-[72px]',
);

export const TextBox = w.div(
  'flex-col justify-center',
);

export const TextBoxH2 = w.h2(
  'font-roboto font-bold text-[32px] lg:text-[48px] leading-[56px] tracking-[0.125rem]',
);

export const TextBoxP = w.p(
  'font-opensans font-normal text-base leading-6 tracking-normal mt-[48px] text-[14px] lg:text-[16px]',
);

export const CardSolo = w.div(
  'w-full xl:w-[1200px] lg:h-auto rounded-[24px] p-[32px] border border-[var(--lime-500)] md:flex flex-wrap gap-2 justify-center items-center md:gap-y-[16px]  gap-y-0 gap-x-[53px] bg-[var(--marine-500)]',
);


export const TextCardSolo = w.p(
  'text-[var(--marine-25)] w-fit: md:w-[45%] lg:w-[425px] font-open-sans font-semibold text-[20px] lg:text-[24px] leading-[32px] tracking-[0px] flex items-center ',
);

export const SpanCardSolo = w.span(
  'w-[14px] h-[14px] bg-[var(--lime-500)] rounded-full mr-[12px] block',
);